import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const sharedCookie = getCookieByName(sharedCookieKey);

        if (jwtFromCookie && sharedCookie) {
            const wholeTokenFromCookie = JSON.parse(sharedCookie);

            let spatFromCookie = wholeTokenFromCookie.spat;

            let result = await apiClient(config).apiMethod({
                method: 'GetThirdPartyPrizes',
                headers: {
                    'X-Auth-Token': jwtFromCookie,
                    'X-Auth-Spat': spatFromCookie,
                },
                args: {
                    state: payload.state ? payload.state : null,
                    page: payload.page ? payload.page : null,
                    pagesize: payload.pagesize ? payload.pagesize : null,
                },
            });
            return {
                ...result,
                page: payload && payload.page ? payload.page : 1,
                pageSize: payload && payload.pagesize ? payload.pagesize : 5,
            };
        } else {
            return {};
        }
    };
};
